import 'css-chunksrc/client/scenes/listEdition/listEditionForm/selectList/styles.scss';export default {
  "selectList": "_selectList_1fctv_1",
  "input": "_input_1fctv_6",
  "selectedItems": "_selectedItems_1fctv_21",
  "selectedItem": "_selectedItem_1fctv_21",
  "list": "_list_1fctv_40",
  "item": "_item_1fctv_57",
  "selectedListItem": "_selectedListItem_1fctv_69",
  "iconBox": "_iconBox_1fctv_73",
  "icon": "_icon_1fctv_73",
  "placeholder": "_placeholder_1fctv_87",
  "opened": "_opened_1fctv_92",
  "invalid": "_invalid_1fctv_102"
};